/* src/app/modules/portal/components/system-overview-switch/system-overview-switch.component.scss */
/*# sourceMappingURL=system-overview-switch.component.css.map */
